import script from "./Cji3CostAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./Cji3CostAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./Cji3CostAnalysis.vue?vue&type=style&index=0&id=2e69c28b&lang=less&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e69c28b"]])

export default __exports__